module.exports = __webpack_public_path__ + "static/media/stofferingen-29.4ce4e0a2.jpg";